import { siteStateStore } from '@/stores/siteStateStore';

import { isOverNDiff } from '@/modules/utils/commonUtils';
import { siteState } from '@/modules/siteState/siteStateGetter';

const props = {} as const;

const state = {
  mousemove: {
    handler: undefined as ((e: MouseEvent) => void) | undefined,
  },
};

export const siteStateManager = {
  init() {
    this.startRaf();

    if (siteState.isHover) {
      this.mousemove();
    }
  },

  reset() {
    this.stopRaf();
    this.removeMousemove();

    siteStateStore.dom.headerEl = null;
    siteStateStore.dom.footerEl = null;
    siteStateStore.dom.splashEl = null;
  },

  startRaf() {
    this.stopRaf(); // 念のため二重起動防止
    siteStateStore.rafId = requestAnimationFrame(() => this.runRaf());
  },
  runRaf() {
    const winWidth = window.innerWidth;
    const winHeight = window.innerHeight;
    const scrollY = window.scrollY;

    if (isOverNDiff(winWidth, siteStateStore.viewport.prev.winWidth) || isOverNDiff(winHeight, siteStateStore.viewport.prev.winHeight)) {
      siteStateStore.viewport.winWidth = winWidth;
      siteStateStore.viewport.winHeight = winHeight;
      siteStateStore.viewport.docWidth = document.documentElement.clientWidth;
      siteStateStore.viewport.docHeight = document.documentElement.clientHeight;

      siteStateStore.viewport.prev.winWidth = winWidth;
      siteStateStore.viewport.prev.winHeight = winHeight;
    }

    if (isOverNDiff(scrollY, siteStateStore.viewport.prev.scrollY)) {
      siteStateStore.viewport.scrollDir = scrollY > siteStateStore.viewport.prev.scrollY ? 'down' : 'up';
      siteStateStore.viewport.scrollY = scrollY;

      siteStateStore.viewport.prev.scrollY = scrollY;
    }

    siteStateStore.rafId = requestAnimationFrame(() => this.runRaf());
  },
  stopRaf() {
    if (siteStateStore.rafId !== null) {
      cancelAnimationFrame(siteStateStore.rafId);
      siteStateStore.rafId = null;
    }
  },

  mousemove() {
    if (state.mousemove.handler) return;

    state.mousemove.handler = (e: MouseEvent) => {
      // ### RUN ###
      this.mousemoveHandler(e);
      // ### RUN END ###
    };

    window.addEventListener('mousemove', state.mousemove.handler);
  },
  mousemoveHandler(e: MouseEvent) {
    siteStateStore.mouse.prev.x = siteStateStore.mouse.x;
    siteStateStore.mouse.prev.y = siteStateStore.mouse.y;
    siteStateStore.mouse.x = e.clientX;
    siteStateStore.mouse.y = e.clientY;

    // -1〜1 に正規化
    siteStateStore.mouse.normalized.x = (e.clientX / siteStateStore.viewport.winWidth) * 2 - 1;
    siteStateStore.mouse.normalized.y = -((e.clientY / siteStateStore.viewport.winHeight) * 2 - 1); // Yは上を正に
  },
  removeMousemove() {
    if (!state.mousemove.handler) return;

    window.removeEventListener('mousemove', state.mousemove.handler);
    state.mousemove.handler = undefined;
  },
};
